import React from 'react';
import { ButtonLabel, ButtonsDiv, Container, Content, Divider, SelectArea } from './styles';
import Button from 'components/Buttom/Button';
import { useHistory } from 'react-router';

const HandleArea = (): JSX.Element => {
  const history = useHistory();
  const path = window.location.pathname;
  return (
    <Container>
      <Content>
        <SelectArea>
          <h2>Selecione a sua área de acordo com o seu tipo de perfil:</h2>
          {/* <ButtonLabel>
              <Button
                text={'ORGANIZADOR DE EXCURSÃO'}
                onClick={() => {
                  if (path.includes('signup')) {
                    history.push('/signup/admin', { profile: 1 });
                  } else {
                    history.push('/login/admin', { profile: 1 });
                  }
                }}
              />
              <label htmlFor="">Organizador de Excursão</label>
            </ButtonLabel> */}
          {/* <Divider /> */}
          <ButtonLabel>
            <Button
              text={'ÁREA ADMINISTRATIVA'}
              onClick={() => {
                path.includes('signup') ? history.push('/signup/admin') : history.push('/login/admin');
              }}
            />
            <label htmlFor=""> Para perfis Imprensa ou Secretaria do Turismo - SETUR </label>
          </ButtonLabel>
        </SelectArea>
      </Content>
    </Container>
  );
};

export default HandleArea;
